import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const IntegrationItemsFilter = (props) => {
  const { integrationItemsId, integrationItemsInfo, onChange } = props;

  return (
    <div className="input">
      <select
        id="integrationItemEq"
        defaultValue={integrationItemsId}
        onChange={onChange}
      >
        <option value=""> -- select a bank -- </option>
        {integrationItemsInfo.map((integrationItemInfo) => (
          <option
            value={integrationItemInfo.id}
            key={integrationItemInfo.id}
          >{`${integrationItemInfo.institutionName}`}</option>
        ))}
      </select>
    </div>
  );
};

export default IntegrationItemsFilter;

IntegrationItemsFilter.propTypes = {
  integrationItemsInfo: PropTypes.arrayOf(PropTypes.shape().isRequired),
  integrationItemsId: PropTypes.string,
  onChange: PropTypes.func,
};

IntegrationItemsFilter.defaultProps = {
  integrationItemsInfo: null,
  integrationItemsId: '',
  onChange: noop,
};
